// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eU8k","importantInfo":"styles_importantInfo__3TmkS"};